import * as R from 'ramda'

import i18n from '../../locales/i18n'
import moment from '../../momentLocale'

const WeekConstants = {
  SUNDAY: 'SUNDAY',
  MONDAY: 'MONDAY',
  TUESDAY: 'TUESDAY',
  WEDNESDAY: 'WEDNESDAY',
  THURSDAY: 'THURSDAY',
  FRIDAY: 'FRIDAY',
  SATURDAY: 'SATURDAY',
}

const FirstDayIndexOfWeek =
  moment.localeData(i18n.language).firstDayOfWeek() || 0

const WeekConstantsPairs = R.toPairs(WeekConstants)

export const OrderedWeekConstants = [
  ...WeekConstantsPairs.slice(FirstDayIndexOfWeek),
  ...WeekConstantsPairs.slice(0, FirstDayIndexOfWeek),
].reduce(
  (acc, [key, item]) => {
    acc[key] = item
    return acc
  },
  {} as typeof WeekConstants,
)

export const WeekDaysShort = {
  [WeekConstants.SUNDAY]: i18n.t('Common:SHORT_WEEK_DAY.SUNDAY'),
  [WeekConstants.MONDAY]: i18n.t('Common:SHORT_WEEK_DAY.MONDAY'),
  [WeekConstants.TUESDAY]: i18n.t('Common:SHORT_WEEK_DAY.TUESDAY'),
  [WeekConstants.WEDNESDAY]: i18n.t('Common:SHORT_WEEK_DAY.WEDNESDAY'),
  [WeekConstants.THURSDAY]: i18n.t('Common:SHORT_WEEK_DAY.THURSDAY'),
  [WeekConstants.FRIDAY]: i18n.t('Common:SHORT_WEEK_DAY.FRIDAY'),
  [WeekConstants.SATURDAY]: i18n.t('Common:SHORT_WEEK_DAY.SATURDAY'),
}

export const WeekDays = {
  [WeekConstants.SUNDAY]: i18n.t('Common:WEEK_DAY.SUNDAY'),
  [WeekConstants.MONDAY]: i18n.t('Common:WEEK_DAY.MONDAY'),
  [WeekConstants.TUESDAY]: i18n.t('Common:WEEK_DAY.TUESDAY'),
  [WeekConstants.WEDNESDAY]: i18n.t('Common:WEEK_DAY.WEDNESDAY'),
  [WeekConstants.THURSDAY]: i18n.t('Common:WEEK_DAY.THURSDAY'),
  [WeekConstants.FRIDAY]: i18n.t('Common:WEEK_DAY.FRIDAY'),
  [WeekConstants.SATURDAY]: i18n.t('Common:WEEK_DAY.SATURDAY'),
}
